(function($, undefined) {
	
	'use strict';
	var showEventDescriptionBtn;
	var oldCmsModifEventBtn;

	var showEventDescription = function() {
		var parentEventRow = $(this).closest('.one-row');

		parentEventRow.toggleClass('description-open').next('.one-event-description-row').find('.one-event-description').slideToggle();
	};

	var getUrlParameter = function(sParam) {
	    var sPageURL = window.location.search.substring(1);
		var sURLVariables = sPageURL.split('&');
		for (var i = 0; i < sURLVariables.length; i++) {
			var sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] == sParam) {
				return sParameterName[1];
			}
		}
	};

	var init = function () {
		showEventDescriptionBtn = $('.show-event-description-btn');
		showEventDescriptionBtn.click(showEventDescription);

		oldCmsModifEventBtn = $('.event-full-action-btn.modify');
		if (oldCmsModifEventBtn.length) {
			eventsModifyEvent(getUrlParameter('edit-event'));
		}
	};
	
	$(window).on('load', function () {
		init();
	});
	
})(jQuery);
